<div class="main ">
    <div class="bottom-decor"></div>
    <header class="main__header">
        <div class="main__card card">
            <div class="card__icon"></div>
            <h1 class="card__title">Сервис</h1>
            <p class="card__description">проведения вступительных и переводных испытаний по общей физической и специальной физической подготовке при зачислении спортсменов на этапы спортивной подготовки</p>
        </div>
    </header>
    <main class="main__main">
        @for (block of blocks; track block) {
            <div [class]="'block '+ (block.class || '')">
                <h2 class="block__title">{{ block.title }}</h2>
                <div class="block__items">
                    @for (item of block.items; track item) {
                        <a [routerLink]="item.link" class="block__item item" *canWatch="item.right">
                            <div class="item__icon" [style]="{background: 'url(' + item.icon + ') no-repeat'}"></div>
                            <div class="item__name">{{ item.name }}</div>
                        </a>
                    }
                </div>
            </div>
        }
    </main>
</div>
